import { render, staticRenderFns } from "./FinanceOperationsTableAdmin.vue?vue&type=template&id=c481b3b0"
import script from "./FinanceOperationsTableAdmin.vue?vue&type=script&lang=js"
export * from "./FinanceOperationsTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports